<!-- 日销售报表 -->
<template>
  <div id="home">
    <div class="bg_black text_white">
      <div class="ninew bodybox">
        <van-nav-bar
          :title="$t('StockReport.yTitle')"
          left-arrow
          fixed
          @click-left="$router.go(-1)"
          :right-text="$t('DayReport.export')" @click-right="onClickExport"
        >
        </van-nav-bar>
      </div>
    </div>

    <div class="bodybox ninew" style="margin-bottom: 30px">
      <!-- <div class="chartBox" id="chart"></div> -->
      <van-cell-group>
        <van-cell>
          <van-row>
            <van-col span="8">{{ $t("StockReport.y") }}</van-col>
            <van-col span="8"
              >{{ $t("DayReport.price") }} ({{ currency }})</van-col
            >
            <van-col span="8">{{ $t("StaffReport.num") }}</van-col>
          </van-row>
          <div slot="right-icon" style="width: 22px"></div>
        </van-cell>
        <template v-for="(item, index) in monthData">
          <van-cell
            center
            is-link
            :to="{
              path: '/StockList',
              query: { year: item.year },
            }"
          >
            <van-row>
              <van-col span="8">{{ item.year }}</van-col>
              <van-col span="8">{{ item.price }}</van-col>
              <van-col span="8">{{ item.number }}</van-col>
            </van-row>
          </van-cell>
        </template>
      </van-cell-group>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      options: {
        title: {
          text: this.$t("StockReport.title"),
        },
        color: ["red"],
        tooltip: {},
        xAxis: {
          name: this.$t("MonthReport.month"),
          data: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            interval: 0,
          },
        },
        yAxis: {
          name: this.$t("MonthReport.money"),
        },
        grid: {
          left: "5.5%",
          // right: '1%',
          bottom: "10%",
          containLabel: true,
        },
        series: [
          {
            name: this.$t("MonthReport.price"),
            type: "bar",
            label: {
              normal: {
                show: true,
                position: "top",
              },
            },
            data: [10, 20, 15, 30, 40, 10, 5, 30, 50, 16, 28, 60],
          },
        ],
      },
      monthData: [],
      monthChart: "",
      year: new Date().getFullYear(),
      currency: "",
    };
  },
  mounted: function () {
    this.month = this.$route.query.month;
    this.getMonthData();
    this.getCurrency();
  },
  methods: {
    // 获取年库存报表
    getMonthData() {
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token,
        },
        url:
          this.$build +
          "/api/store/" +
          sessionStorage.actShopId +
          "/eachYearInventory",
      })
        .then((res) => {
          console.log(res.data.data);
          if (res.data.status == 200) {
            this.monthData = res.data.data;
            // this.options.xAxis.data = res.data.month; //横坐标
            // this.options.series[0].data = res.data.price; //数值
            this.monthChartInit();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
              });
            }
          }
        })
        .catch((err) => {});
    },
    monthChartInit() {
      this.monthChart.setOption(this.options);
    },
    // 获取店铺设置的货币
    getCurrency() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token,
        },
        url:
          this.$build + "/api/store/" + sessionStorage.actShopId + "/currency",
      })
        .then((res) => {
          console.log(res);
          if (res.data.status == 200) {
            this.currency = res.data.data.unit;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
              });
            }
          }
        })
        .catch((err) => {
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message"),
          });
        });
    },
    // 导出报表
    onClickExport() {
      window.location.href =
        this.$build +
        "/api/store/" +
        sessionStorage.actShopId +
        "/exportReport?param=eachYearInventory";
    },
  },
};
</script>
<style scoped>
.StockList {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background-color: #f3f3f3;
}
/deep/ .van-nav-bar__left {
  padding: 0;
  left: -4px;
}
/deep/ .van-nav-bar__right {
  padding: 0;
}
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-cell__left-icon,
.van-cell__right-icon {
  font-size: 22px;
}
/deep/ .van-nav-bar__right .van-nav-bar__text {
  color: #fff;
}
.chartBox {
  width: 100%;
  min-height: 240px;
  background-color: #fff;
  padding-top: 15px;
}
.content {
  color: #000;
}
.title {
  font-size: 14px;
  color: #444;
}
.totalPrice {
  position: absolute;
  right: 0px;
  top: 0;
}
</style>
/deep/ .van-nav-bar__left {
  padding: 0;
  left: -4px;
}
/deep/ .van-nav-bar__right {
  padding: 0;
}
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-cell__left-icon,
.van-cell__right-icon {
  font-size: 22px;
}
/deep/ .van-nav-bar__right .van-nav-bar__text {
  color: #fff;
}
.chartBox {
  width: 100%;
  min-height: 240px;
  background-color: #fff;
}
.content {
  color: #000;
}
</style>


// WEBPACK FOOTER //
// src/Shop/YearsStockdetail.vue